export default "__VITE_ASSET__C35FGz7p__"